var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 136.705,
    viewBox: "0 0 182 136.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customers-blank",
    transform: "translate(-725 -526.296)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M122.911,30c-11.668-.4-22.78-4.172-33.391-8.293S68.4,13.025,57.01,10.842c-7.325-1.4-15.7-1.6-21.6,2.318-5.681,3.786-7.516,10.3-8.5,16.355-.743,4.554-1.179,9.347.855,13.611,1.413,2.96,3.919,5.448,5.654,8.284,6.034,9.865,1.769,22.03-4.768,31.662-3.065,4.518-6.625,8.834-8.992,13.638s-3.461,10.328-1.39,15.243c2.052,4.868,6.943,8.516,12.241,11.085,10.761,5.219,23.436,6.712,35.805,7.559,27.372,1.871,54.888,1.062,82.332.249,10.157-.3,20.357-.6,30.348-2.174,5.549-.873,11.276-2.257,15.306-5.6a12.816,12.816,0,0,0,2.953-16.743c-5.747-8.924-21.634-11.139-25.656-20.714-2.21-5.271.059-11.141,3.274-16.029C181.76,59.1,193.314,49.9,193.921,37.916c.418-8.232-5.136-16.476-13.725-20.372-9-4.083-21.486-3.57-28.124,3.189C145.231,27.686,133.214,30.363,122.911,30Z",
    transform: "translate(707.833 516.375)",
    fill: "#2699fb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_Followers_re_6k3g",
    transform: "translate(751.694 565.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M302.117,223.563H199.861a2.636,2.636,0,0,1-2.633-2.633V157.877a1.931,1.931,0,0,1,1.929-1.929H302.788a1.964,1.964,0,0,1,1.962,1.962v63.02A2.636,2.636,0,0,1,302.117,223.563Z",
    transform: "translate(-197.191 -154.224)",
    fill: "#f2f2f2",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M318.558,247.9h-95.3a2.46,2.46,0,0,1-2.534-2.372V190.617a1.823,1.823,0,0,1,1.877-1.76h96.581a1.854,1.854,0,0,1,1.909,1.789v54.879A2.46,2.46,0,0,1,318.558,247.9Z",
    transform: "translate(-216.938 -181.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M304.518,149.123H197v-1.34a2.645,2.645,0,0,1,2.642-2.641H301.876a2.645,2.645,0,0,1,2.642,2.641Z",
    transform: "translate(-196.996 -145.142)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_987",
    "data-name": "Ellipse 987",
    cx: 0.683,
    cy: 0.683,
    r: 0.683,
    transform: "translate(4.119 1.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_988",
    "data-name": "Ellipse 988",
    cx: 0.683,
    cy: 0.683,
    r: 0.683,
    transform: "translate(6.713 1.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_989",
    "data-name": "Ellipse 989",
    cx: 0.683,
    cy: 0.683,
    r: 0.683,
    transform: "translate(9.307 1.311)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M287.189,242.908H270.347a2.552,2.552,0,0,0-2.553,2.553v11.462a2.552,2.552,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V245.461a2.553,2.553,0,0,0-2.553-2.553Z",
    transform: "translate(-256.497 -227.308)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M463.793,245.457V256.92a2.553,2.553,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V245.457a2.553,2.553,0,0,0-2.553-2.553H466.346A2.553,2.553,0,0,0,463.793,245.457Z",
    transform: "translate(-421.221 -227.305)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M659.793,245.457V256.92a2.553,2.553,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V245.457a2.553,2.553,0,0,0-2.553-2.553H662.346A2.553,2.553,0,0,0,659.793,245.457Z",
    transform: "translate(-585.946 -227.305)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M267.793,404.457V415.92a2.553,2.553,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V404.457a2.553,2.553,0,0,0-2.553-2.553H270.346A2.553,2.553,0,0,0,267.793,404.457Z",
    transform: "translate(-256.496 -360.933)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M463.793,404.457V415.92a2.553,2.553,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V404.457a2.553,2.553,0,0,0-2.553-2.553H466.346A2.553,2.553,0,0,0,463.793,404.457Z",
    transform: "translate(-421.221 -360.933)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M659.793,404.457V415.92a2.553,2.553,0,0,0,2.553,2.553h16.842a2.553,2.553,0,0,0,2.553-2.553V404.457a2.553,2.553,0,0,0-2.553-2.553H662.346A2.553,2.553,0,0,0,659.793,404.457Z",
    transform: "translate(-585.946 -360.933)",
    fill: "#2699fb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_990",
    "data-name": "Ellipse 990",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(18.76 20.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M313.674,333.711H302.944a5.325,5.325,0,0,1,.959-1.312,5.248,5.248,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,313.674,333.711Z",
    transform: "translate(-286.039 -301.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_991",
    "data-name": "Ellipse 991",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(50.035 20.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M509.674,333.711H498.944a5.324,5.324,0,0,1,.959-1.312,5.248,5.248,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,509.674,333.711Z",
    transform: "translate(-450.764 -301.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_992",
    "data-name": "Ellipse 992",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(81.31 20.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M705.674,333.711H694.944a5.322,5.322,0,0,1,.959-1.312,5.248,5.248,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,705.674,333.711Z",
    transform: "translate(-615.489 -301.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_993",
    "data-name": "Ellipse 993",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(18.76 45.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M313.674,492.711H302.944a5.325,5.325,0,0,1,.959-1.312,5.249,5.249,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,313.674,492.711Z",
    transform: "translate(-286.039 -434.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_994",
    "data-name": "Ellipse 994",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(50.035 45.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M509.674,492.711H498.944a5.324,5.324,0,0,1,.959-1.312,5.249,5.249,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,509.674,492.711Z",
    transform: "translate(-450.764 -434.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_995",
    "data-name": "Ellipse 995",
    cx: 3.51,
    cy: 3.51,
    r: 3.51,
    transform: "translate(81.31 45.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M705.674,492.711H694.944a5.322,5.322,0,0,1,.959-1.312,5.248,5.248,0,0,1,3.723-1.541h1.366A5.264,5.264,0,0,1,705.674,492.711Z",
    transform: "translate(-615.489 -434.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M781.81,753.177H740.163a.16.16,0,1,1,0-.319H781.81a.16.16,0,1,1,0,.319Z",
    transform: "translate(-653.358 -655.887)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M655.511,557.779h-1.956l-.931-7.546h2.887Z",
    transform: "translate(-548.487 -462.434)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M637.188,594.018h3.773v2.375h-6.148A2.375,2.375,0,0,1,637.188,594.018Z",
    transform: "translate(-533.518 -499.233)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M701.511,557.779h-1.956l-.931-7.546h2.887Z",
    transform: "translate(-587.147 -462.434)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M683.188,594.018h3.773v2.375h-6.148A2.375,2.375,0,0,1,683.188,594.018Z",
    transform: "translate(-572.178 -499.233)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M903.7,491.812a1.714,1.714,0,0,1-.329-2.608l-1.288-18.28,3.71.36.1,17.9a1.723,1.723,0,0,1-2.2,2.626Z",
    transform: "translate(-789.573 -418.941)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M848.071,595.974l-2.153-.1a.718.718,0,0,1-.684-.712c-.568-8.763-1.354-18.16-.15-21.79a.718.718,0,0,1,.821-.716l8.616,1.251a.714.714,0,0,1,.615.705c1.1,4.3,1.15,12.092,1.108,20.191a.718.718,0,0,1-.718.724H853.2a.715.715,0,0,1-.709-.606l-1.432-9.106a.558.558,0,0,0-1.106.02l-1.137,9.51a.721.721,0,0,1-.713.633Z",
    transform: "translate(-741.14 -504.431)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M851.668,468.278a10.839,10.839,0,0,0-4.1-1.4.705.705,0,0,1-.487-.267.714.714,0,0,1-.149-.543L849,450.739a5.3,5.3,0,0,1,3.09-4.142,5.155,5.155,0,0,1,5.01.393q.106.071.208.144a5.294,5.294,0,0,1,2.016,5.517c-1.266,5.179-1.7,13.669-1.775,15.318a.712.712,0,0,1-.466.639,7.193,7.193,0,0,1-2.429.433A6.083,6.083,0,0,1,851.668,468.278Z",
    transform: "translate(-743.22 -398.099)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M904.334,469.616a.715.715,0,0,1-.3-.543l-.272-4.927a1.978,1.978,0,0,1,3.885-.627l1.194,4.4a.719.719,0,0,1-.505.881l-3.4.921A.715.715,0,0,1,904.334,469.616Z",
    transform: "translate(-790.987 -411.49)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_996",
    "data-name": "Ellipse 996",
    cx: 3.919,
    cy: 3.919,
    r: 3.919,
    transform: "translate(106.255 38.579)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M781.043,452.924a1.69,1.69,0,0,1,.038.262l6.855,3.954,1.666-.959,1.776,2.325-3.564,2.54-7.82-6.169a1.675,1.675,0,1,1,1.049-1.953Z",
    transform: "translate(-685.071 -402.727)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M843.162,459.543a.715.715,0,0,1,.206-.583l3.489-3.489a1.978,1.978,0,0,1,3.059,2.476l-2.484,3.828a.719.719,0,0,1-.993.211l-2.953-1.916A.716.716,0,0,1,843.162,459.543Z",
    transform: "translate(-740.052 -405.466)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M866.453,384.8a1.266,1.266,0,0,1-2.184-.7,1.3,1.3,0,0,1,0-.248,5.755,5.755,0,0,0,.256-1.4.733.733,0,0,0-.134-.343c-.583-.78-1.95.349-2.5-.357-.337-.433.059-1.115-.2-1.6-.342-.639-1.353-.324-1.987-.674-.706-.389-.664-1.472-.2-2.131a3.351,3.351,0,0,1,2.541-1.293,6.815,6.815,0,0,1,2.871.56,5.738,5.738,0,0,1,2.713,1.881,4.592,4.592,0,0,1,.464,3.91A7.37,7.37,0,0,1,866.453,384.8Z",
    transform: "translate(-753.505 -339.201)",
    fill: "#2f2e41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCustomers);
export default __webpack_public_path__ + "static/media/no-customers.0f61046086d84fda93672637b48c7c0f.svg";
export { ForwardRef as ReactComponent };